var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRibbon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 59,
    viewBox: "0 0 260 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M242.409 26.916C246.073 22.2992 257.291 8.868 257.291 8.868L249.626 6.7124C208.516 -4.84874 167.764 0.88207 128.354 6.4232C89.5319 11.8822 52.8618 17.0386 16.1434 6.7124L0 2.17243C0 2.17243 13.619 26.0234 17.4423 32.4665C13.7947 36.9347 2.46492 50.1044 2.46492 50.1044L10.2284 52.2877C27.7443 57.2137 45.1918 59 62.5021 59C85.8178 59 108.882 55.7571 131.5 52.5766C170.322 47.1176 206.992 41.9612 243.71 52.2874L260 56.8688C260 56.8688 246.226 33.2172 242.409 26.916Z",
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbon);
export default __webpack_public_path__ + "static/media/ribbon.d9fb9684323ee39c9a7daf2324aaa204.svg";
export { ForwardRef as ReactComponent };